import { List, Map } from "immutable";
import { uniq } from "lodash";
import { useMemo } from "react";

import { makeGetCourseAssignments } from "seneca-common/features/assignments/features/student-assignments/state/selectors";
import Assignment from "seneca-common/features/assignments/state/models/Assignment";
import {
  getFutureAssignments,
  getOverdueAssignments
} from "seneca-common/features/assignments/state/selectors/state/assignments/assignments";
import { sortByDueDateAsc } from "seneca-common/features/assignments/state/selectors/state/assignments/sortAssignments";
import { useMemoSelector } from "seneca-common/utils/hooks/selectors";
import { useMoment } from "seneca-common/utils/hooks/useMoment";

import useCourseId from "features/classroom/routes/classroom/routes/course/hooks/useCourseId";

export default function useGetAssignmentIds() {
  const courseId = useCourseId();
  const now = useMoment();
  const assignments = useMemoSelector(makeGetCourseAssignments, courseId);

  const assignmentIds = useMemo(() => {
    const overdueAssignmentIds = assignments
      ? sortAndFilterAssignments(getOverdueAssignments(assignments, now))
      : [];

    const futureAssignmentIds = assignments
      ? sortAndFilterAssignments(getFutureAssignments(assignments, now))
      : [];

    return uniq([...overdueAssignmentIds, ...futureAssignmentIds]);
  }, [assignments, now]);

  return { assignmentIds };
}

function sortAndFilterAssignments(
  assignments: List<Assignment> | Map<string, Assignment>
) {
  return assignments
    .sort(sortByDueDateAsc)
    .toList()
    .map(({ id }) => id)
    .filter(Boolean)
    .toArray() as string[];
}
